@if (tab() !== OrderPlanningMode.OUTSOURCING && !order().outsourcingData) {
  <app-order-modal-vehicles
    [status]="status()"
    [order]="order()"
    [vehicle]="vehicle()"
    [trailer]="trailer()"
    [drivers]="drivers()"
    [driversLoading]="driversLoading()"
    [showHeading]="status() !== OrderStatus.VEHICLE_SEARCH"
    [close$]="close$()"
  ></app-order-modal-vehicles>

  @if (vehicle()) {
    @if (hasApprovedVehicle()) {
      <app-drivers-tachograph
        [primaryDriver]="drivers()?.[0]"
        [secondaryDriver]="drivers()?.[1]"
        type="order"
        [serviceTime]="currentPointServiceTime()"
      ></app-drivers-tachograph>
    }

    @if (
      tab() === OrderPlanningMode.AUTO &&
      hasEngineProposal() &&
      (!hasApprovedVehicle() || missingAssignment())
    ) {
      <app-order-modal-decision-buttons
        [(tab)]="tab"
        [order]="order()"
        [close$]="close$()"
      ></app-order-modal-decision-buttons>
    }
  }
} @else if (order().outsourcingData) {
  <app-order-modal-outsourcing-data
    [order]="order()"
    [close$]="close$()"
  ></app-order-modal-outsourcing-data>
}
